export const WEBSOCKET_PING_INTERVAL_MS = 20000;
export const WEBSOCKET_PONG_TIMEOUT_MS = 60000;

export enum WebsocketClientEvent {
  SESSION_REGISTRATION = "sessionRegistration",
  PING = "ping",
}

export enum WebsocketRawMessage {
  PONG = "pong",
  USERS_UPDATED = "usersUpdated",
  TICKETS_UPDATED = "eventsUpdated",
  GROUPS_UPDATED = "groupsUpdated", // we have it, but it's not handled on the UI.
  SUBSCRIPTION_UPDATED = "subscriptionUpdated",
  OUTBOUND_PROXY_TEST_SUCCESSFUL = "outboundProxyTestSuccessful",
  OUTBOUND_PROXY_TEST_FAILED = "outboundProxyTestFailed",
  OUTBOUND_PROXY_BLOCK_MODE_AVAILABLE = "outboundProxyBlockModeAvailable",
  OUTBOUND_PROXY_BLOCK_MODE_ACTIVE = "outboundProxyBlockModeActive",
  VPN_CONNECTION_UPDATED = "vpnConnectionUpdated",
}

export enum WebsocketMessageCode {
  SHELL_COMMAND_RESPONSE = "shellCommandResponse",
  SHELL_SESSION_OPENED = "shellSessionOpened",
  SHELL_SESSION_CLOSED = "shellSessionClosed",
  SHELL_COMMAND_CONFIRMATION_REQUEST = "shellCommandConfirmationRequest",
  SHELL_SESSION_OPENING_FAILED = "shellSessionOpeningFailed",
  TOO_MANY_SHELL_SESSIONS_OPENED = "tooManyShellSessionsOpened",
  IMPORT_USERS_FROM_CSV = "importUsersFromCsv",
  IMPORT_ALLOW_BLOCK_LIST = "importAllowBlockListFromCsv",
  OPERATOR_EXPORT_ADDED = "operatorExportCreated",
  CSV_EXPORT = "csvExport",
  ONBOARDING_UPDATED = "ONBOARDING_UPDATED",
}
